import { Popper } from 'react-popper';
import OutsideClickHandler from 'components/OutsideClickHandler';
import { ContentWrapper } from './primitives';

const DesktopContentWrapper = ({ onClose, children }) => (
  <Popper
    placement="bottom-start"
    modifiers={[
      {
        name: 'offset',
        options: { offset: [0, 4] },
      },
      {
        name: 'preventOverflow',
        options: { padding: { top: 4 } },
      },
      {
        name: 'flip',
        options: { padding: { top: 4 } },
      },
    ]}
  >
    {({ ref, style }) => (
      <OutsideClickHandler onClickOutside={onClose}>
        <ContentWrapper zIndex={1} ref={ref} style={style}>
          {children}
        </ContentWrapper>
      </OutsideClickHandler>
    )}
  </Popper>
);

export default DesktopContentWrapper;
